<!-- libs/core/shell/src/lib/layout/shell-footer/shell-footer.component.html -->
<footer class="l-footer" role="contentinfo">

  <div class="l-container l-footer__body">

    <!-- Coluna 1 — Marca + endereço -->
    <div class="l-footer__brand">
      @if (brand.brandLogoUrl()) {
        <img
          class="l-footer__logo"
          [src]="brand.brandLogoUrl()"
          [alt]="brand.appName()"
          loading="lazy"
        />
      }

      <div class="l-footer__brand-meta">
        @if (brand.appName()) {
          <span class="l-footer__brand-name">{{ brand.appName() }}</span>
        }

        @if (formattedAddress()) {
          <span class="l-footer__address">
            <i class="bx bx-map-pin" aria-hidden="true"></i>
            {{ formattedAddress() }}
          </span>
        }
      </div>
    </div>

    <!-- Coluna 2 — Badge central da plataforma -->
    @if (brand.mascoteLogo()) {
      <div class="l-footer__badge" aria-hidden="true">
        <img
          class="l-footer__badge-img"
          [src]="brand.mascoteLogo()"
          alt=""
          role="presentation"
          loading="lazy"
        />
      </div>
    }

    <!-- Coluna 3 — Contato -->
    @if (brand.companyContact()) {
      <address class="l-footer__contact" aria-label="Informações de contato">
        <span class="l-footer__contact-label">Contato</span>

        @if (whatsappUrl()) {
          <a
            class="l-footer__wa-btn"
            [href]="whatsappUrl()"
            target="_blank"
            rel="noopener noreferrer"
            aria-label="Falar pelo WhatsApp"
          >
            <i class="bx bxl-whatsapp" aria-hidden="true"></i>
            WhatsApp
          </a>
        }

        @if (brand.companyContact()?.phone; as phone) {
          <a class="l-footer__contact-link" [href]="'tel:' + phone">
            <i class="bx bx-phone" aria-hidden="true"></i>
            {{ formatPhone(phone) }}
          </a>
        }

        @if (brand.companyContact()?.email; as email) {
          <a class="l-footer__contact-link" [href]="'mailto:' + email">
            <i class="bx bx-envelope" aria-hidden="true"></i>
            {{ email }}
          </a>
        }

        @if (instagramUrl(); as igUrl) {
          <a
            class="l-footer__contact-link"
            [href]="igUrl"
            target="_blank"
            rel="noopener noreferrer"
          >
            <i class="bx bxl-instagram" aria-hidden="true"></i>
            {{ brand.companyContact()?.instagram }}
          </a>
        }
      </address>
    }

  </div>

  <!-- Legbar -->
  <div class="l-container l-footer__row">
    <span class="l-footer__text">
      © {{ year }} {{ brand.appName() || cfg.appName }}
    </span>
    <span class="l-footer__muted">v0.1</span>
  </div>

</footer>
